// Pure predicate for the mobile-only immersive landscape gate.
//
// Immersive (video-first) landscape is a phone-scale experience: a landscape
// viewport whose short side is phone-sized. Deliberately viewport-based — NOT
// user-agent or the ?device param — so it reacts to the DevTools device
// toolbar (incl. responsive mode) and real devices alike. Desktop windows have
// a taller short side and keep the video + shop-window split.
//
// Kept free of sizeManager / browser globals so the breakpoint logic stays
// testable in isolation; orientationManager wraps it with the live viewport
// size. Behaviour is covered end-to-end by the pix-e2e suite.

export const IMMERSIVE_MAX_SHORT_SIDE = 500;

export function isImmersiveSize(
  size: { width: number; height: number } | null | undefined,
): boolean {
  if (!size || size.width <= size.height) {
    return false; // portrait (or square) is never immersive
  }
  return Math.min(size.width, size.height) <= IMMERSIVE_MAX_SHORT_SIDE;
}
